
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';

@Injectable()
export class ModalWindowGuard  {
  private matDialog = inject(MatDialog);


  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.appHasOpenedDialogs();
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    return this.appHasOpenedDialogs();
  }

  private appHasOpenedDialogs(): boolean {
    return _.isEmpty(this.matDialog.openDialogs);
  }

}
